import aprovadoresRotas from './aprovadores/AprovadoresRotas'
import financeiroRotas from './financeiro/FinanceiroRotas'
import gestoresRotas from './gestores/GestoresRotas'
import gerentesRotas from './gerentes/GerentesRotas'
import apoiosRotas from './apoios/ApoiosRotas'
import relatoriosConveniosRotas from './relatoriosconvenios/ConveniosRelatoriosRotas'
import relatoriosCotratosRotas from './relatorioscontratos/ContratosRelatoriosRotas'
import conveniosFornecedoresRotas from './convenios/fornecedor/FornecedoresRotas'
import conveniosGestoresRotas from './convenios/gestor/GestoresRotas'
import conveniosFinanceiroRotas from './convenios/financeiro/FinanceiroRotas'

export default {
    path: 'gescon',
    name: 'Gescon',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [aprovadoresRotas, financeiroRotas, conveniosFornecedoresRotas, gestoresRotas, gerentesRotas, apoiosRotas, relatoriosConveniosRotas, relatoriosCotratosRotas,
        conveniosGestoresRotas,conveniosFinanceiroRotas]
}
